import { Mutation } from 'vuex';
import { IModuleState } from './types';

export const setMembers: Mutation<IModuleState> = (state, payload) => {
  state.members.data = payload.data;
  state.members.pageNum = payload.pageNum;
  state.members.pageSize = payload.pageSize;
  state.members.total = payload.total;
  state.members.loading = !!payload.loading;
};

export const setServiceStates: Mutation<IModuleState> = (state, payload) => {
  state.serviceStates.data = payload.data;
  state.serviceStates.loading = !!payload.loading;
};

// 确认弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.name = payload.name;
  state.confirm.title = payload.title;
  state.confirm.content = payload.content;
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
};

// 设置列表搜索条件
export const setSearchParams: Mutation<IModuleState> = (state, payload) => {
  state.searchParams = payload;
};

// 是否有 owner 品牌
export const setHasOwnerBrand: Mutation<IModuleState> = (state, payload) => {
  state.hasOwnerBrand = payload;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
